import type { SessionUser } from '../net/session';

/**
 * The sidebar's identity block, from the signed-in user.
 *
 * The artboard draws `G`, `Acacia Breweries Ltd`, `Grace O. · org admin`: the
 * user's initial, the organization's name, then the user and their role. The
 * role label is the API's role with the underscore dropped, which gives the
 * artboard's `org admin` for `org_admin`. The organization's name needs
 * `GET /v1/organization`, which the first G unit that loads it wires, so that line
 * carries the user's name, DEFERRED 1.4.
 */
export function identityOf(user: SessionUser) {
  const role = user.role.replace(/_/g, ' ');
  return {
    initial: (user.name.trim()[0] ?? '?').toUpperCase(),
    name: user.name,
    detail: `${user.name} · ${role}`,
  };
}
